export default "__VITE_ASSET__fc73bdb8__"